var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleCoolDex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00161 42.6654C3.60508 42.6654 3.23687 42.5664 2.89698 42.3685C2.5571 42.1706 2.27386 41.9161 2.04727 41.6051C1.84901 41.2658 1.72155 40.8982 1.6649 40.5023C1.60826 40.0782 1.65074 39.6541 1.79236 39.23L4.12907 32.444H10.247L8.67503 36.9397H22.8227L23.7149 34.395H29.8329L28.1759 39.23C28.0343 39.6541 27.7935 40.0782 27.4537 40.5023C27.1138 40.8982 26.7172 41.2658 26.2641 41.6051C25.8392 41.9161 25.386 42.1706 24.9045 42.3685C24.423 42.5664 23.984 42.6654 23.5875 42.6654H4.00161ZM6.29583 26.0398L6.76317 24.7674C6.81982 24.6543 6.86231 24.5412 6.89063 24.4281C6.94728 24.315 7.01809 24.1878 7.10306 24.0464H33.2742C33.2459 24.103 33.2317 24.2302 33.2317 24.4281C33.2317 24.4281 33.2034 24.5412 33.1467 24.7674L32.6794 26.0398H6.29583ZM7.95277 22.9861C8.4626 22.5054 9.02907 22.1096 9.6522 21.7986C10.2753 21.4875 10.8418 21.332 11.3516 21.332H30.9375C31.4473 21.332 31.9005 21.4875 32.297 21.7986C32.6936 22.1096 32.9768 22.5054 33.1467 22.9861H7.95277ZM25.5418 29.0935L26.2641 27.0577H12.1164L11.3941 29.0935H5.27618L6.04092 26.8456H32.4245L31.6597 29.0935H25.5418ZM4.21404 32.1471L5.06375 29.6448H11.2242L10.332 32.1471H4.21404Z",
    fill: "url(#paint0_linear_1772_11178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6871 42.6654L33.2134 32.444H39.3314L37.7594 36.9397H51.9071L53.4791 32.444H59.597L57.2603 39.23C57.1187 39.6541 56.8779 40.0782 56.538 40.5023C56.1982 40.8982 55.8016 41.2658 55.3484 41.6051C54.9236 41.9161 54.4704 42.1706 53.9889 42.3685C53.5074 42.5664 53.0684 42.6654 52.6718 42.6654H29.6871ZM62.3586 24.0464C62.3302 24.103 62.3161 24.2302 62.3161 24.4281C62.3161 24.4281 62.2878 24.5412 62.2311 24.7674L61.7638 26.0398H35.4227L36.1025 24.0464H62.3586ZM36.4424 22.9861L37.0372 21.332H60.0219C60.5317 21.332 60.9849 21.4875 61.3814 21.7986C61.7779 22.1096 62.0612 22.5054 62.2311 22.9861H36.4424ZM54.6262 29.0935L55.3484 27.0577H35.0828L35.1253 26.8456H61.5089L60.7441 29.0935H54.6262ZM33.2984 32.1471L34.1906 29.6448H40.3085L39.4163 32.1471H33.2984ZM53.564 32.1471L54.4562 29.6448H60.5317L59.682 32.1471H53.564Z",
    fill: "url(#paint1_linear_1772_11178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_11178",
    x1: 31.9996,
    y1: 21.332,
    x2: 31.9996,
    y2: 42.6654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_11178",
    x1: 31.9996,
    y1: 21.332,
    x2: 31.9996,
    y2: 42.6654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCoolDex);
export default __webpack_public_path__ + "static/media/PurpleCoolDEX.1efbe28a84d7eb7a17f9fd412b29d03d.svg";
export { ForwardRef as ReactComponent };